import React, {Component} from 'react';
import Countdown, {zeroPad} from 'react-countdown';
const moment = require('moment');

const Renderer = ({ days, hours, minutes, seconds }) => {
	return (
		<ul>
			<li><span id="days">{zeroPad(days)}</span>days</li>
			<li className="timer-after">:</li>
			<li><span id="hours">{zeroPad(hours)}</span>Hours</li>
			<li className="timer-after">:</li>
			<li><span id="minutes">{zeroPad(minutes)}</span>Minutes</li>
			<li className="timer-after">:</li>
			<li><span id="seconds">{zeroPad(seconds)}</span>Seconds</li>
		</ul>
	)
};

class CustomCountdown extends Component {
	duration(t0, t1){
		var day = new Date();
		var then = moment.utc(day.toUTCString());
		var now = moment.utc(t0);

		let ms = now.diff(then)

		var d, h, m, s;
		s = Math.floor(ms / 1000);
		m = Math.floor(s / 60);
		s = s % 60;
		h = Math.floor(m / 60);
		m = m % 60;
		d = Math.floor(h / 24);
		h = h % 24;

		return {days: d, hours: h, minutes: m, seconds: s};
	}

	constructor(props) {
		super(props);

		var a = new Date('2020-05-15 12:00:00'),
			b = new Date(),
			diff = (+a - +b);

		this.state = {
			timerOn: true,
			timerStart: 0,
			timerTime: diff
		}
	}

	startTimer = (diff) => {
		this.setState({
			timerOn: true,
			timerTime: this.state.timerTime,
		});

		this.timer = setInterval(() => {
			const newTime = this.state.timerTime - 10;

			if (newTime >= 0) {
				this.setState({
					timerTime: newTime
				});
			}
			else {
				clearInterval(this.timer);
				this.setState({ timerOn: false });
			}
		}, 10);
	};

	componentDidMount() {
		this.startTimer();
	}

	render(){
		let {days, hours, minutes, seconds} = this.duration('2020-05-15 12:00:00');
		return <Renderer days={days} hours={hours} minutes={minutes} seconds={seconds}  />
	}
}

class Hero extends Component {
	render() {
		var a = new Date('2020-05-15 12:00:00'),
			b = new Date(),
			diff = (+a - +b);

		return (
			<section className="offer bg-color_gradient paddingLeft-120">
				<h1>The Incident Response Challenge</h1>

				<p className="sub-title">Do you have the IR skills to top the leaderboard?</p>

				{diff <= 0 &&
					<div className={'comp-over'}>
						<p>The competition is over! Thanks to all the 2,500+ participants. The winner will be announced shortly.</p>

						<p>You can download the challenges’ full solutions <a rel="noopener noreferrer" target={'_blank'} href="https://go.cynet.com/incident-response-challenge-answers">here</a>. The website challenges are will still be available for anyone that wants to practice their IR skills.</p>
					</div>
				}

				{diff > 0 &&
					<div className="timer">
						<div className="box-shadow">
							<p>competition closes in</p>
							<CustomCountdown/>
						</div>
					</div>
				}
			</section>
		);
	}
}

export default Hero